<template>
  <div class="question-slider f-3">
    <div
      ref="leftArrow"
      class="arrow left-arrow as-flex main-center cross-center"
      @click="goScroll(0)"
    >
      <i class="el-icon-caret-left"></i>
    </div>
    <div ref="content" class="content as-flex main-start cross-center">
      <template v-for="(item,index) in movieListBriefInfo">
        <transition-group name="flip-list" :key="'movie_' + index" class="as-full-height">
          <div
            :key="'movie_' + index"
            @click="(e)=>{toggleActive(item.id);setCurrentQuestionRect(e)}"
            :class="['movie-box', 'as-flex', 'flex-vertical', 'main-center', 'cross-center',!movieActive[item.id]?'is-not-active':'']"
            ref="imgContainer"
          >
            <template v-if="item.poster_url">
              <img :src="item.poster_url" class="img" alt>
            </template>
            <template v-else>
              <img src="../../assets/images/movie-poster.png" class="img" alt>
            </template>
            <span class="movie-info title f-2">{{item.title}}</span>
            <span class="movie-info f-1 fc-gray-2 title">{{item.launch}}</span>
          </div>
        </transition-group>
      </template>
    </div>
    <div
      ref="rightArrow"
      class="arrow right-arrow as-flex main-center cross-center"
      @click="goScroll(1)"
    >
      <i class="el-icon-caret-right"></i>
    </div>
  </div>
</template>

<script>
import debounceClass from "../../utils/debounce";
const _debounce = new debounceClass().debounce;
import { clone } from "lodash";
import { mapGetters } from "vuex";

export default {
  name: "moviesSoftScroll",
  props: {
    movieListBriefInfo: {}
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      movieActive: "movie/getMovieActive"
    })
  },
  methods: {
    toggleActive(id) {
      let temp = clone(this.movieActive);
      temp[id] = !temp[id];
      this.$store.commit("movie/updateMovieActive", temp);
    },
    setCurrentQuestionRect(e) {
      let el = e.currentTarget;
      let curLeft = el.getBoundingClientRect().left;
      let curRight = el.getBoundingClientRect().right;
      let containerLeft = this.$refs.leftArrow.getBoundingClientRect().right;
      let containerRight = this.$refs.rightArrow.getBoundingClientRect().left;
      if (containerLeft > curLeft && containerLeft < curRight) {
        //左边遮挡
        let customizedStep = Math.abs(containerLeft - curLeft);
        this.goScroll(0, customizedStep);
      } else if (containerRight > curLeft && containerRight < curRight) {
        //右边遮挡
        let customizedStep = Math.abs(curRight - containerRight);
        this.goScroll(1, customizedStep);
      }
    },
    goScroll(flag, customizedStep) {
      let el = this.$refs.content;
      let curTransformLeft = 0;
      let maxScrollRight = el.scrollWidth - el.clientWidth;
      let step = undefined;
      if (customizedStep) {
        step = customizedStep;
      } else {
        step = el.clientWidth;
      }
      let detail = undefined;
      if (el.style.transform.match(/([0-9]+)/g)) {
        curTransformLeft = Number(
          el.style.transform.match(/((\-|\+)?[0-9]+)/g)[0]
        );
      } else {
        curTransformLeft = 0;
      }
      if (flag === 0) {
        //scroll left
        detail = curTransformLeft + step >= 0 ? 0 : curTransformLeft + step;
        el.style.transform = `translateX(${detail}px)`;
      } else {
        detail =
          curTransformLeft - step <= -maxScrollRight
            ? -maxScrollRight
            : curTransformLeft - step;
        el.style.transform = `translateX(${detail}px)`;
      }
    },
    initScroll() {
      let el = this.$refs.content;
      el.style.transform = ``;
    },
    handleResize: _debounce(function() {}, 500)
  },
  watch: {},
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
};
</script>

<style lang="scss" scoped>
.question-slider {
  width: 100%;
  height: 100%;
  position: relative;
  // border: 1px solid #efefef;
  overflow-x: hidden;
}
.arrow {
  position: absolute;
  width: 20px;
  background-color: #ffffff;
  z-index: 5;
  &:hover {
    background-color: #f8f5f5;
  }
  &.left-arrow {
    left: 0;
    top: 0;
    bottom: 0;
  }
  &.right-arrow {
    right: 0;
    top: 0;
    bottom: 0;
  }
}
.content {
  position: absolute;
  bottom: 0;
  top: 0;
  left: 20px;
  right: 20px;
  overflow: visible;
  transition: transform 0.4s ease-in-out;
}
.movie-box {
  height: 100%;
  padding: 0 15px;
  flex-grow: 0;
  width: 100px;
  position: relative;
  &.is-not-active {
    background: #fff;
    opacity: 0.35; //谷歌等现代浏览器
    filter: alpha(opacity=35); //兼容IE浏览器
  }
  .title {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.img {
  height: 65%;
}

//hide scrollbar
div {
  overflow: -moz-hidden-unscrollable;
  height: 100%;
}

div::-webkit-scrollbar {
  display: none;
}

div {
  -ms-overflow-style: none;
}
</style>
